export const logError = (error) => {
  console.error(error);
};

export const log = (...args) => {
  console.log(...args);
};
